import React from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Column, Button, Card } from '@resurs/midas-react'
import PaymentMethodHeader from './PaymentMethodHeader'
import PaymentPerMonth from '../shared/PaymentPerMonth'
import { getText } from '../../../../internal/TextLabels'

const DisabledMethod = ({
  onPageLoading,
  handleNext,
  customerType,
  paymentMethodsExist,
  paymentMethod,
}) => (
  <Container>
    <Columns>
      <Column col12>
        <PaymentMethodHeader
          description={getText('payApply.paymentMethod.methodNotAvailable')}
        >
          {!paymentMethod.disabledResurs ? (
            <PaymentPerMonth
              customerType={customerType}
              paymentMethodsExist={paymentMethodsExist}
            />
          ) : null}
        </PaymentMethodHeader>
        <div style={{ paddingBottom: '1rem' }} />
        <Card>
          <div style={{ padding: '0  1rem 1rem' }}>
            <Columns>
              {paymentMethod.disabledResurs ? (
                <Column col12>
                  <h5>{paymentMethod.description}</h5>
                  <p>Payment method is disabled.</p>
                  <br />
                  <p>
                    <strong>Reason:</strong>{' '}
                    {paymentMethod.status.disabledReasons}
                  </p>
                  <p>
                    <strong>Valid from:</strong> {paymentMethod.validFrom}
                  </p>
                  <p>
                    <strong>Valid to:</strong> {paymentMethod.validTo}
                  </p>
                </Column>
              ) : (
                <>
                  <Column col12 colMd12 colSm12>
                    {getText('payApply.paymentMethod.contactBank')}
                  </Column>
                  <Column col3 colMd3 colSm12>
                    {getText('payApply.paymentMethod.phoneNbrDesc')}:
                  </Column>
                  <Column col9 colMd9 colSm12>
                    {getText('payApply.paymentMethod.phoneNbr')}
                  </Column>
                  <Column col3 colMd3 colSm12>
                    {getText('payApply.paymentMethod.rbHoursDesc')}
                  </Column>
                  <Column col9 colMd9 colSm12>
                    {getText('payApply.paymentMethod.rbHours')
                      .split(',')
                      .map(text => (
                        <div key={text}>{text}</div>
                      ))}
                  </Column>
                </>
              )}
            </Columns>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                text={getText('payApply.paymentMethod.updatePage')}
                loading={onPageLoading}
                onClick={e => handleNext(e, { refreshPaymentMethods: true })}
                size="small"
              />
            </div>
          </div>
        </Card>
      </Column>
    </Columns>
  </Container>
)

DisabledMethod.propTypes = {
  onPageLoading: PropTypes.bool.isRequired,
  handleNext: PropTypes.func.isRequired,
  customerType: PropTypes.string.isRequired,
  paymentMethodsExist: PropTypes.bool,
}

DisabledMethod.defaultProps = {
  paymentMethodsExist: false,
}

export default DisabledMethod
